import { Box, BoxProps, Link, LinkTypeMap, Typography } from '@material-ui/core'
import { PropsWithChildren, ReactNode } from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'
import { StyledNavLinkInner } from '../footer/styles'

export interface IMainWrapperNavBarLinkProps extends BoxProps {
  to: string
  linkIcon: ReactNode
  onClickHandler?: (ev) => void
  iconTextVertAlign?: string
}

const StyledLink = styled(Link)<{ component?: ReactNode; to?: string }>`
  & {
    height: 100%;
  }
`

const StyledBox = styled(Box)`
  & {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const MainWrapperNavBarLink = (props: PropsWithChildren<IMainWrapperNavBarLinkProps>) => {
  const { children, onClickHandler, linkIcon, to, iconTextVertAlign } = props

  const theme = useTheme()
  const { pathname } = useLocation()

  return (
    <Box width="100%" height="100%" {...props}>
      <StyledLink component={RouterLink} to={to} onClick={onClickHandler}>
        <StyledNavLinkInner iconTextVertAlign={iconTextVertAlign}>
          <StyledBox>{linkIcon}</StyledBox>
          <StyledBox>
            <Typography variant="caption" noWrap>
              <Box fontWeight="bold" color={to === pathname ? theme.colors.primary : theme.colors.accent1}>
                {children}
              </Box>
            </Typography>
          </StyledBox>
        </StyledNavLinkInner>
      </StyledLink>
    </Box>
  )
}
